import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { pipe, take } from 'rxjs'
import { parseJson } from '../utils/helpers'

@Injectable()
export class ConfigService {
  private _etiquetas: IEtiquetas
  private _mensajes: IMensajes
  private _tooltips: ITooltips
  private _sec: ISec
  private _uri: IURI
  private _validaciones: IValidaciones
  constructor(private http: HttpClient) {
  }

  readData() {
    const promise = this.http
      .get('assets/config.json', { responseType: 'text' }).toPromise();

    promise.then(data => {
      const config = parseJson(data)
      this._etiquetas = config['Etiquetas']
      this._mensajes = config['Mensajes']
      this._sec = config['Sec']
      this._uri = config['URI']
      this._tooltips = config['Tooltips']
      this._validaciones = config['Validaciones']
    })

    return promise
  }

  public get sec(): ISec {
    return this._sec
  }

  public get mensajes(): IMensajes {
    return this._mensajes
  }

  public get etiquetas(): IEtiquetas {
    return this._etiquetas
  }
  public get tooltips(): ITooltips {
    return this._tooltips
  }

  public get validaciones(): IValidaciones {
    return this._validaciones
  }

  public get AdmURI(): string {
    return this.URI(this._uri.Adm)
  }

  public get ProductosURI(): string {
    return this.URI(this._uri.Productos)
  }

  public get TablasURI(): string {
    return this.URI(this._uri.Tablas)
  }



  get CuentasURI(): string {
    return this.URI(this._uri.Cuentas)
  }


  get ParametroURI(): string {
    return this.URI(this._uri.Parametro)
  }
  get CotizacionesURI(): string {
    return this.URI(this._uri.Cotizaciones)
  }
  get CotizacionesURI2(): string {
    return this.URI("OpenApi")
  }

  get PEPURI(): string {
    return this.URI(this._uri.PedidoEspecialesPlanta)
  }
  get PVURI(): string {
    return this.URI(this._uri.PedidosVenta)
  }
  get NCURI(): string {
    return this.URI(this._uri.NotasCredito)
  }
  get ReporteURI(): string {
    return this.URI(this._uri.Reportes)
  }
  get PAURI(): string {
    return this.URI(this._uri.PedidoAbastecimiento)
  }
  get TPURI(): string {
    return this.URI(this._uri.TransferenciaPlanta)
  }
  get TDURI(): string {
    return this.URI(this._uri.TransferenciaDistribuidores)
  }
  public get ServerURI(): string {

    const url_local = window.location.protocol + '//' + window.location.host + window.location.pathname;
    return this._uri.Server
  }

  public URI(controllerName: string): string {
    // this._uri.Server +
    return this._uri.Api + controllerName + '/'
  }



  public get uri(): IURI {
    return this._uri
  }

  get UsuarioURI(): string {
    return this.URI(this._uri.Usuario)
  }
  get UsuarioURI2(): string {
    return this.URI("OpenApi")
  }
}

interface IURI {
  Server: string
  Adm: string
  Api: string
  Bayer: string
  Cuentas: string
  NotasCredito: string
  Parametro: string
  PedidoEspecialesPlanta: string
  PedidoAbastecimiento: string
  TransferenciaPlanta: string
  TransferenciaDistribuidores: string
  Cotizaciones: string
  PedidosVenta: string
  Productos: string
  Reportes: string
  Tablas: string
  Usuario: string
  CondicionesDeUso: {
    Link: string
    Titulo: string
  }

  PoliticaDePrivacidad: {
    Link: string
    Titulo: string
  }

  PieDeImprenta: {
    Link: string
    Titulo: string
  }

  PoliticaDeCookies: {
    Link: string
    Titulo: string
  }

  DetallesTecnicos: {
    Link: string
    Titulo: string
  }

  SocialMedia: {
    Facebook: string,
    Twitter: string,
    Instagram: string,
    Linkedin: string,
    YouTube: string
  }
}

interface IMensajes {
  TituloCierreSesion: string,
  TituloSesionExpirada: string,
  TituloClaveModificada: string,
  TituloCorreoEnviado: string,
  TituloSuccess: string,
  TituloInfo: string,
  TituloWarning: string,
  TituloSinResultados: string,
  TituloError: string,
  TituloAviso: string,
  AltaExitosa: string,
  AltaExcelExitosa: string,
  ModificacionExitosa: string,
  AprobacionPedidoExitosa: string,
  RechazoPedidoExitoso: string,
  EliminacionExitosa: string,
  CreditoVencido: string,
  DescuentosNegativos: string,
  ClienteSinDisrtribuidores: string,
  DistribuidorSinSucursales: string,

  CuentaCorriente: {
    CreditoAVencer: string,
    CreditoVencido: string,
  }

  Usuarios: {
    AUsuario: string,
    AUsuariosExcel: string,

    BUsuario: string,
    MUsuario: string,
    RolesInactivos: string
  }

  LoginUsuario: {
    Bienvenido: string,
    CambioContraseña: string,
    CierreSesion: string,
    ClaveModificada: string,
    ClaveModificada2: string,
    Conectado: string,
    ConfirmacionContraseña: string,
    ContraseñaExpirada: string,
    EmailContacto: string,
    EmailContraseña: string,
    RegistroUsuario: string,
    SesionExpirada: string,
    UsuarioInexistente: string,
    VerificarCuenta: string
  },

  Error0: string,
  Error401: string,
  Error403: string,
  Error404: string,
  Error500: string,
  ErrorConexionDbBriefCropScience: string,
}

interface IEtiquetas {
  EnviadoDistribuidor: string,
  NombrePDF: string,
  Email: string
  Acciones: string,
  FechaEntrega: string,
  BotonAExcel: string,
  ItemDistribuidor: string,
  ItemPlanta: string,
  BotonCPlantillaExcel: string,
  BotonDescargarExcel: string
  BotonReporte: string,
  ExportarExcel: string,
  Buscar: string,
  CalleNroDireccionEntrega: string,
  Cantidad: string,
  CantidadProgramada: string,
  CantidadRequerida: string,
  CantidadDevolucion: string,
  CantidadDisponible: string,
  CantidadComprada: string,
  CantidadVendida: string,
  Cargo: string,
  CargoAutorizante: string,
  CiudadDireccionEntrega: string,
  Cliente: string,
  BuscarCliente: string,
  BuscarVendedor: string,
  Codigo: string,
  Comentario: string,
  Compania: string,
  Copyright: string
  CopyrightFooter: string,
  CPDireccionEntrega: string,
  CuentaDistribuidor: string,
  CuitCliente: string,
  Defecto: string,
  Descargando: string,
  Descargar: string,
  Descripcion: string,
  DescripcionItemDescuento: string,
  Descuento: string,
  DescuentoCategoria: string,
  DescuentoDiscrecional: string,
  DireccionEntrega: string,
  Division: string,
  Estado: string,
  EstadoAnterior: string,
  EstadoNuevo: string,
  Fecha: string,
  FechaAprobacionRetencion: string,
  FechaCreacion: string,
  FechaDesde: string,
  FechaEstado: string,
  FechaHasta: string,
  FechaInicio: string,
  FechaVencimiento: string,
  FilterDivision: string,
  FilterEstado: string,
  FilterPais: string,
  FilterRegion: string,
  FilterProducto: string,
  Glosa: string,
  Habilitacion: string
  IconoADM: string,
  IconoCuentas: string,
  IconoPedidos: string,
  IconoHome: string,
  IconoProductos: string,
  IconoReclamos: string,
  IconoTablas: string,
  IconoReportes: string,
  Id: string,
  IdDivision: string,
  IdGrupoCliente: string,
  IdMoneda: string,
  Moneda: string,
  IdNivel: string,
  IdPais: string,
  IdPlanta: string,
  Planta: string,
  IdProducto: string,
  IdSalesOffice: string,
  IdTaxClassification: string,
  IdTipoCondicion: string,
  IdTipoListaPrecios: string,
  IdZonaVendedor: string,
  Importe: string,
  ImporteDevolucion: string,
  ImporteDevolucionLocal: string,
  Item: string,
  ItemFactura: string,
  KeyWordsErrorSnackbar: string[],
  LeyendaContacto: string,
  LogoBayerBlanco: string,
  LogoBayerColor: string,
  MailContacto: string,
  MensajeIntegracion: string,
  MensajeRetencion: string,
  MotivoDevolucion: string,
  MotivoNC: string,
  MotivoRetencion: string,
  Nivel: string,
  NivelVendedor: string,
  No: string,
  NoApruebaAnteriores: string,
  NombreApellido: string,
  NombreApellidoAprobadorRetencion: string,
  NombreCliente: string,
  NombreClienteDireccionEntrega: string,
  NombreDistribuidor: string,
  NroCliente: string
  NroClienteDireccionEntrega: string,
  NroFactura: string,
  NroLinea: string,
  NroOrdenSAP: string
  NroPedido: string
  NroCotizacion: string
  NroPedidoRelacionado: string,
  NroRemito: string,
  Pais: string,
  Porcentaje: string,
  PrecioFinal: string,
  PrecioKGL: string,
  PrecioUnitarioFinal: string,
  PrecioUnitarioLista: string,
  PrecioVenta: string,
  Producto: string,
  Recargo: string,
  Region: string,
  RetencionAprobada: string,
  SalesOffice: string,
  SalesOrg: string,
  Si: string,
  SinRegistros: string,
  Stock: string,
  StorageLocation: string,
  Subiendo: string,
  TerminoPago: string,
  TipoEntrega: string,
  TipoListaPrecios: string
  TipoOrden: string,
  TipoRetencion: string,
  TituloApp: string,
  TituloCerrarMenu: string,
  Total: string,
  TotalDescuento: string,
  TotalDevolucion: string,
  TotalDevolucionLocal: string,
  TotalFactura: string,
  TotalLocal: string,
  TotalPrecioKGL: string,
  TotalOriginal: string,
  TotalRegistro: string,
  TotalRegistros: string,
  TotalUSD: string,
  ValidarImporte: string,
  ValidarMenor365: string,
  ValidarTipoNC: string,
  Ver: string,
  Volver: string,
  ZonaVendedor: string,
  ZonaVendedorSeleccionada: string,
  IdTerminoPago: string,
  Mes: string
  Anio: string
  Sucursal: string
  Distribuidor: string
  CantidadDisponibleCuota: string,
  CantidadDisponibleVigente: string;
  CantidadPedidosNoFacturados: string;
  CantidadDisponibleVenta: string;
  CantidadRecibida: string;
  CuotaCant: string;
  FiltrarDireccion: string,
  CuotaPlanta: string,
  CuotaDistribuidor: string,
  TipoNC: string,
  ExpoTransferencias: string,
  Telefono1: string,
  Telefono2: string,
  Cuenta: string,
  EmailOpcional: string
  FechaPrecio: string
  Descuentos: string,
  NroOC: string,
  CodigoArticuloMyV: string,
  CodigoArticuloCoagra: string,
  CodigoBodegaMyV: string
  CodigoBodegaCoagra: string
  Direccion: string
  Nombre: string
  ShipTo: string
  MenuUsuario: {
    CerrarSesion: string,
    CambiarClave: string,
  },

  CambiarClave: {
    Ayuda: string,
    Boton: string,
    ClaveActual: string,
    ClaveNueva: string,
    LeadText1: string,
    LeadText2: string,
    LeadText3: string,
    LeadText4: string,
    LeadText5: string,
    Path: string,
    RepetirClaveNueva: string,
    RouterLink: string,
    Titulo: string,

  }
  ConfirmarEmail: {
    Titulo: string
    Path: string
  }
  ConfirmacionCotizacion: {
    Titulo: string
    Path: string
  }
  Parametros: {
    Titulo: string,
    Path: string,
    BotonAParametro: string

  }

  Productos: {
    Titulo: string,
    Path: string,
    LineaProducto: string,
    IdPlanta: string,
    Icon: string,
    ConversorUnidadMedidaVenta: string,
    IdUnidadMedidaVenta: string,
    IdUnidadMedidaBase: string,
    UnidadesCaja: string,
    UnidadesPallet: string,
    CodigoArticuloCoagra: string,
    CodigoArticuloMyV: string
  },

  TiposListasPrecios: {
    AplicaDescuentos: string,
    BotonATipoListaPrecio: string,
    CircuitoVentaAnticipada: string,
    Cliente: string,
    GenerarProforma: string,
    Icon: string,
    Path: string,
    Titulo: string,
  },

  ItemsParametros: {
    BotonAItemParametro: string,
    FiltrarParametro: string,
    NombreExcelReporte: string,
    Path: string,
    Titulo: string,
    Headers: {
      IdItem: string,
      DescripcionParametro: string
    }
    ExcelAltaMasiva: {
      P1: string,
      Headers: {
        IdParametro: string,
        DescripcionParametro: string,
        IdItem: string,
        DescripcionItem: string,
        Habilitacion: string,
      }
    }

  }
  Procesos: {
    Titulo: string,
    Icon: string,
    Path: string
  }

  Usuarios: {
    Titulo: string,
    Path: string,
    Icon: string,
    BotonAUsuario: string,
    Headers: {
      Nombre: string,
      Email: string,
      UserName: string,
      Rol: string
    },
    RolesInactivos: string[],
    Dialog: {
      Apellido: string
      Bloqueado: string
      Compania: string
      Cuits: string
      CuitsAutocomplete: string
      Email: string
      EmailConfirmado: string
      RecibeMailAutorizacion: string
      Nombre: string
      Pais: string
      Rol: string
      SalesOrg: string
      Division: string
      Region: string
      UserName: string

    }
    ExcelReporte: {
      Nombre: string,
      P1: string,
      P2: string,
      P3: string,
      Headers: {
        Apellido: string,
        Bloqueado: string,
        Cuit: string,
        Email: string,
        EmailConfirmado: string,
        RecibeMailAutorizacion: string,
        FechaFinBloqueo: string,
        FechaPrimerInicioSesion: string,
        IntentosFallidos: string,
        Nombre: string,
        PrimerInicioSesion: string,
        RazonSocial: string,
        UltimoCambioClave: string,
        UltimoInicioSesion: string,
        UserName: string,
      }
    }
  },
  TerminosPago: {
    BotonATerminoPago: string,
    CondicionLarga: string,
    CreditoExcedido: string,
    Descripcion: string,
    DiasVencer: string,
    FormaPago: string,
    Icon: string,
    Id: string,
    Path: string,
    TarjetaCredito: string,
    Titulo: string,
  }
  PageNotFound: {
    ButtonText: string,
    LeadText1: string,
    LeadText2: string,
    Path: string,
    Text1: string,
    Titulo: string,
  }
  Home: {
    arialabel: string,
    Ayuda1: string,
    Ayuda2: string,
    FooterText: string,
    HeaderImage1: string,
    HeaderImage2: string,
    HeaderImage3: string,
    HeaderImage4: string,
    HeaderText: string,
    HeroImage1: string,
    HeroText2: string,
    HeroText3: string
    Path: string,
    Titulo: string,
  }


  Login: {
    Ayuda: string,
    Boton: string,
    Clave: string,
    CorreoElectronico: string,
    LeadText1: string,
    LeadText2: string,
    LeadText3: string,
    LeadText4: string,
    Path: string,
    SolicitudClaveNueva: string,
    Titulo: string,
    VerificarCuenta: string,
  },

  VerificarCuenta: {
    Ayuda: string
    Boton: string
    CorreoElectronico: string
    HeaderImage1: string
    LeadText1: string
    LeadText2: string
    LeadText3: string
    LeadText4: string
    Path: string
    SolicitudClaveNueva: string
    Titulo: string
    UserName: string
    YaEstoyVerificado: string
  },


  IconosSnackBar: {
    AccessDenied: string,
    Block: string,
    Error: string,
    Info: string,
    Key: string,
    Search: string,
    Sucess: string,
    Warning: string
  }
  TiposCambio: {
    BotonATipoCambio: string,
    FechaCambio: string,
    Icon: string,
    IdMonedaDestino: string,
    IdMonedaOrigen: string,
    Path: string,
    Titulo: string,
    Valor: string
  }
  GruposClientes: {
    Path: string,
    Icon: string,
    BotonAGrupoCliente: string,
    Titulo: string
  }
  ListasPrecios: {
    BotonACabecera: string,
    Titulo: string,
    Path: string,
    Icon: string,
    Cabeceras: {

      DescuentoDiscrecional: string,
      FechaValidaDesde: string,
      FechaValidaHasta: string,
      FormaPago: string,
      Moneda: string,
      PrecioFijo: string,
      TerminoPago: string,
      Valorizacion: string

    }
    Items: {
      FechaValidaDesde: string,
      FechaValidaHasta: string,
      IdUnidadMedidaBase: string,
      LineaProducto: string,
      ListaPrecio: string,
      Moneda: string,
      Tasa: string,
    }


  }
  Regiones: {
    Path: string
    Icon: string
    BotonARegion: string
    Titulo: string
    UsuarioCoordinadorVentas: string
  }
  Inventarios: {
    CantidadDisponible: string,
    CantidadDisponibleVenta: string,
    CantidadDisponibleVigente: string,
    CantidadPedidos: string,
    CantidadTransito: string,
    CantidadTransitoDevolucion: string
    Estado: string,
    FechaVencimientoLote: string,
    FiltrarDeposito: string,
    FiltrarDireccion: string,
    Icon: string,
    IdLote: string,
    IdProducto: string,
    IdUnidadMedidaBase: string,
    Path: string,
    Producto: string,
    Titulo: string,
    Excel: {
      DistribuidoresXCantidadDisponible: {
        P1: string,
        Headers: {
          NombreDistribuidor: string
          IdSucursal: string
          Ciudad: string
          CalleNro: string
          IdProducto: string
          Producto: string
          CantidadDisponible: string
          StockNoRestringido: string
          CantidadPedidos: string
          CantidadDisponibleVenta: string
          Estado: string
        }
      }
      DistribuidoresXLote: {
        P1: string,
        Headers: {
          NombreDistribuidor: string
          IdSucursal: string
          Ciudad: string
          CalleNro: string
          IdProducto: string
          Producto: string
          CantidadSAP: string
          CantidadDisponible: string
          CantidadTransito: string
          CantidadTransitoDevolucion: string
          Unidades: string
          UnidadMedidaBase: string
          Estado: string
          FechaVencimiento: string
          Lote: string
        }
      }

    }
  },
  Depositos: {
    Path: string
    BotonADeposito: string
    Titulo: string,
    Icon: string,
    Cliente: string,
    NombreClienteDireccionEntrega: string,
    NroClienteDireccionEntrega: string
  }
  UbicacionesAlmacenamientos: {
    Path: string
    Icon: string
    BotonAUbicacionAlmacenamiento: string
    Titulo: string
    NombreClienteDireccionEntrega: string
    NroClienteDireccionEntrega: string
  }
  ZonasVendedores: {
    Path: string
    Icon: string
    BotonAZonaVendedor: string
    Titulo: string
    UsuarioVendedor: string
  }

  Distribuidores: {
    EmailDistribuidor: string
    DiasAlCierre: string
    BotonADistribuidor: string
    DireccionEnvio: string
    Directo: string
    Icon: string
    IdZonaVendedor: string
    NroCasaMatriz: string
    NroCliente: string
    Path: string
    Titulo: string
    UsuarioRed: string
  }
  Divisiones: {
    Path: string
    BotonADivision: string
    Titulo: string
    SalesOfficeCuenta: string
  }
  Cuentas: {
    Email: string
    Bloqueo: string,
    CalleNro: string,
    Ciudad: string,
    CodigoPostal: string,
    CreditoUtilizado: string,
    Cuit: string,
    DBEKR: string,
    DireccionEnvio: string,
    DireccionFacturacion: string,
    FechaVtoCredito: string,
    FuncionPartner: string
    Icon: string,
    IdCondicionPago: string,
    IdDivision: string,
    IdGrupoCliente: string,
    IdMoneda: string,
    IdRegion: string,
    IdTipoCliente: string,
    IdTipoCredito: string,
    IdZonaVendedor: string,
    LimiteCredito: string,
    Nombre: string,
    NroCliente: string,
    NroClientePartner: string,
    Path: string,
    Provincia: string,
    Region: string,
    SitioInternet: string,
    Status: string,
    Telefono: string,
    Titulo: string,
  }
  Campanias: {
    Titulo: string
    Path: string
  }
  Numeradores: {
    Titulo: string
    Path: string
    Numero: string
  }
  AutorizacionesDto: {
    Path: string
    Icon: string
    BotonAWorkflowDto: string
    Titulo: string
  }
  AutorizacionesNC: {
    Path: string
    Icon: string
    BotonAWorkflowNC: string
    Titulo: string
  }
  NotasCredito: {
    TipoNC: string,
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    NC: {
      Titulo: string
      Path: string
      Direccion: string
      Icon: string

    }
  }
  PedidosVenta: {
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    PV: {
      Titulo: string
      Path: string
      Direccion: string
      Icon: string

    }
  }
  PedidosEspecialesPlanta: {
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    PEP: {
      Titulo: string
      Path: string
      Icon: string
      FechaPrecio: string
      Planta: string
    }
  }
  PedidosEspecialesPlantaAnticipada: {
    Titulo: string
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    PEPA: {
      Titulo: string
      Path: string
      Icon: string
      FechaPrecio: string
      Planta: string
    }
  }
  PedidosVentaAnticipada: {
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    PVA: {
      Titulo: string
      Path: string
      Direccion: string
      Icon: string

    }
  }
  Cotizaciones: {
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    Cotizacion: {
      Titulo: string
      Path: string
      Direccion: string
      Icon: string
      EmailOpcional: string
      Email: string

    }
  }
  PedidosAbastecimiento: {
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    PA: {
      Titulo: string
      Path: string
      Icon: string

    }
  }
  TransferenciasPlanta: {
    NroClienteDireccionRetiro: string,
    NombreClienteDireccionRetiro: string,
    CiudadDireccionRetiro: string,
    CalleNroDireccionRetiro: string,
    CPDireccionRetiro: string,
    DireccionEntrega: string,
    PlantaEnvio: string,
    AlmacenEnvio: string,
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    TP: {
      Titulo: string
      Path: string
      Icon: string

    }
  }
  TransferenciasDistribuidores: {
    SucursalOrigen: string
    SucursalDestino: string
    CalleNroDireccionOrigen: string,
    CPDireccionOrigen: string,
    CiudadDireccionOrigen: string,
    DireccionOrigen: string,
    NombreClienteDireccionOrigen: string,
    NroClienteDireccionOrigen: string,
    AlmacenOrigen: string,
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    TD: {
      Titulo: string
      Path: string
      Icon: string

    }
  }
  TiposLPPorTerminoPago: {
    Path: string
    Icon: string
    BotonALPPorTerminoPago: string
    Titulo: string
  }
  TiposLPPorGrupoCliente: {
    Path: string
    Icon: string
    BotonALPPorGrupoCliente: string
    Titulo: string
  }
  MotivosDevolucionNC: {
    Path: string
    Icon: string
    BotonAMotivoDevolucionNC: string
    Titulo: string
    TipoNC: string
    WFAprobacion: string
  }
  CuotasPlantas: {
    Path: string
    Icon: string
    BotonACuotaPlanta: string
    Titulo: string
    ExcelAltaMasiva: {
      P1: string,
      NombrePlantilla: string,
      Headers: {
        IdPlanta: string,
        IdUbicacionAlmacenamiento: string
      }
    }
  }
  CuotasDistribuidores: {
    Path: string
    Icon: string
    BotonACuotaDistribuidor: string
    Titulo: string
    ExcelAltaMasiva: {
      P1: string,
      NombrePlantilla: string,
      Headers: {
        IdSucursal: string,
        NroClienteDistribuidor: string
      }
    }
  }
  ReportesPedidos: {
    NombreExcelReporte: string
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    Excel: {
      P1: string,
      Headers: {
        TipoOrden: string
        NroPedido: string
        NroOrdenSAP: string
        GrupoCliente: string
        ListaPrecios: string
        TerminoPago: string
        MotivoRetencion: string
        MotivoDevolucion: string
        FechaEstado: string
        NroCliente: string

      }
    }
  }
  ReportesPedidosDetallados: {
    NombreExcelReporte: string
    Buscador: {
      Titulo: string
      Path: string
      Icon: string
    }
    Excel: {
      P1: string,
      Headers: {
        NroComprobante: string
        PrecioLista: string
        PrecioUnitarioFinal: string
        TotalDescuento: string
        TipoOrden: string
        NroPedido: string
        FechaEstado: string
        NroOrdenSAP: string
        MotivoRetencion: string
        MotivoDevolucion: string
        NroCliente: string
        GrupoCliente: string
        TerminoPago: string
        ListaPrecios: string
      }
    }
  }
  ShipToDistribuidores: {
    
    Path: string
    BotonAShipToDistribuidor: string
    Titulo: string
    Excel: {
      P1:String
      Headers:{
        ShipTo: string
        Nombre: string	
        Ciudad: string	
        CalleNro: string	
        SucDistribuidor: string	
      	NroCliente: string

      }
    }
  }

}

interface ITooltips {
  Mas: string
  Editar: string,
  Ver: string,
  Eliminar: string,
  CambiarEstado: string,
  LimpiarVendedor: string
  LimpiarProducto: string
  Copiar: string

  Login: {
    SolicitudClaveNueva: string
  }
  VerificarCuenta: {
    IrALogin: string
  }
  Footer: {
    Facebook: string,
    Twitter: string,
    Instagram: string,
    Linkedin: string,
    YouTube: string
  }
}

interface IValidaciones {
  
  ArchivoExcelInvalido: string
  ArchivoExcelVacio: string
  ArchivoInvalido: string,
  ArchivoPNGInvalido: string,
  Cantidad: string,
  CantidadRequerida: string,
  CantidadComprada: string,
  Cliente: string,
  Codigo: string,
  Comentario: string,
  Compania: string,
  Descripcion: string,
  DimensionesLogo: string,
  DireccionEntrega: string,
  Division: string,
  FechaDesde: string
  FechaHasta: string
  Id: string,
  IdDivision: string,
  IdGrupoCliente: string,
  IdMoneda: string,
  IdNumero: string,
  IdPlanta: string,
  IdRegion: string,
  IdSalesOffice: string
  IdSucursal: string,
  IdTerminoPago: string,
  ListaPrecios: string,
  NroClienteDistribuidor: string,
  Pais: string,
  PrecioFinal: string,
  RangoFechasValido: string
  Region: string,
  SalesOrg: string,
  SizeLogo: string,
  StorageLocation: string,
  ZonaVendedor: string,
  NroClienteDireccionEntrega: string,
  NombreClienteDireccionEntrega: string,
  NroPedidoRelacionado: string,
  MotivoRetencion: string,
  Porcentaje: string,
  TipoDescuento: string,
  Importe: string,
  Producto: string,
  CuotaPlanta: string,
  CuotaDistribuidor: string,
  Mes: string,
  Anio: string,
  IdUbicacionAlmacenamiento: string,
  CuotaCant: string,
  IdLote: string,
  Telefono1: string,
  Telefono2: string,
  Email: string
  FechaEntrega: string,
  NroOC: string,

  NotasCredito: {
    IdTipoNC: string
    MotivoDevolucion: string
    CantidadDevolucion: string,
    IdLote: string,
    ItemFactura: string,
    PrecioVenta: string,
  }

  Login: {
    EscribirClave: string
    EscribirComentario: string
    EscribirNumeroPositivo: string
    EscribirUsuarioRed: string
  },
  CambiarClave: {
    ConfirmacionClaveNueva: string,
    EscribirClave: string,
    ValidacionClaveNueva: string[],
    ValidacionClaveNueva1: string,
    ValidacionClaveNueva2: string,
    ValidacionClaveNueva3: string,
    ValidacionClaveNueva4: string,
    ValidacionClaveNueva5: string,
  }
  VerificarCuenta: {
    EscribirUsuarioRed: string
  }
  Productos: {
    UnidadesCaja: string
    UnidadesPallet: string
  }
  Usuarios: {
    Dialog: {
      Apellido: string,
      Compania: string,
      Division: string,
      Email: string,
      Nombre: string,
      Pais: string,
      Region: string,
      Rol: string,
      SalesOrg: string,
      UserName: string,
    },

  }

  TerminosPago: {
    Dialog: {
      FormaPago: string,
    }
  }

  ItemsParametros: {
    Dialog: {
      DescripcionParametro: string,
    }
  }
  TiposCambio: {
    Dialog: {
      IdMonedaOrigen: string,
      IdMonedaDestino: string,
      FechaCambio: string,
      Valor: string
    }
  }
  ListasPrecios: {
    Cabeceras: {
      Dialog: {
        FormaPago: string
        TerminoPago: string
        FechaValidaDesde: string
        Moneda: string
        FechaValidaHasta: string
      }
    }
    Items: {
      Dialog: {
        Tasa: string

      }
    }
  }
  Depositos: {
    IdPlanta: string
    NroClienteDireccionEntrega: string,
    NombreClienteDireccionEntrega: string,
  }
  UbicacionesAlmacenamientos: {
    IdPlanta: string
    NroClienteDireccionEntrega: string,
    NombreClienteDireccionEntrega: string,
  }
  ZonasVendedores: {
    UsuarioVendedor: string
  }
  Distribuidores: {
    DireccionEnvio: string
    IdZonaVendedor: string
    NroCasaMatriz: string
    NroCliente: string
    UsuarioRed: string
    DiasAlCierre: string
    EmailDistribuidor: string
  }
  MotivosDevolucionNC: {
    TipoNC: string
    Cargo: string
  }
  TransferenciasPlanta: {
    DireccionRetiro: string
    DireccionEntrega: string
  }
}

interface ISec {

  Key1: string
  Key2: string
  Key3: string
  Key4: string
  Key5: string
  Key6: string
  Key7: string
  Key8: string
  Key9: string
  Key10: string
}

